import throttle from 'lodash-es/throttle';
import $ from 'jquery';

export default function init(container) {
  const event_live_statuses = $(container).find('.event__live-status');
  if (!event_live_statuses) {
    return;
  }

  event_live_statuses.each((idx, el) => {
    var event_live_status = $(el);
    var live_start = Date.parse($(el).data("live-start"));
    var live_end = Date.parse($(el).data("live-end"));

    if (!live_start) {
      return;
    }

    update_live_status(event_live_status, live_start, live_end);

    var iframe = $(el).find('.event__live-video iframe');
    var iframe_resize_func = throttle(() => {
      if (iframe.length) {
        live_video_embed_resize(iframe, event_live_status);
      }
    }, 500);
    iframe_resize_func();

    var live_video_dropdown = $('.live-video-dropdown');
    var event_live_video = event_live_status.find('.event__live-video');
    var event_page_image = $('.events__image .featured-image');

    var slide_event_live_video = function () {
      event_live_status.toggleClass('js-live-video-opened');
      $('body').toggleClass('js-live-video-opened');

      if (event_live_status.hasClass('js-live-video-opened')) {
        event_live_video.slideDown(500);
        event_page_image.slideUp(500);
        iframe_resize_func();
      } else {
        event_live_video.slideUp(500);
        event_page_image.slideDown(500);
        iframe_resize_func();
      }
    };

    live_video_dropdown.on('click', (event) => {
      event.preventDefault();
      slide_event_live_video();
    });

    $(window).on('resize', iframe_resize_func);

    if (live_video_dropdown.is(':visible')) {
      $(() => {
        setTimeout(() => slide_event_live_video(), 1500);
      });
    }

    setInterval(() => {
      update_live_status(event_live_status, live_start, live_end);
    }, 5000);
  });
}

function live_video_embed_resize(iframe_el, event_live_status) {
  var wrapper = iframe_el.closest('.event__live-video');

  var original_width = wrapper.data('original-width');
  var original_height = wrapper.data('original-height');

  if (!original_width) {
    original_width = iframe_el.width();
    wrapper.data('original-width', original_width);
  }

  if (!original_height) {
      original_height = iframe_el.height();
      wrapper.data('original-height', original_height);
  }

  var new_height = original_height / original_width * wrapper.outerWidth(true);
  iframe_el.height(new_height);
  iframe_el.width(wrapper.outerWidth(true));

  event_live_status.addClass('size-calculated');
}

function check_live_status_situation (event_live_status_el, start_unix, end_unix) {
  var plara_template = event_live_status_el.closest('.plara-template');
  var current_time = get_current_unix_time();
  var class_modification_elements = event_live_status_el.add(plara_template);

  class_modification_elements.removeClass('js-live-before js-live-after js-live-ongoing');
  if (current_time < start_unix) {
    class_modification_elements.addClass('js-live-before');
  } else if (current_time > end_unix) {
    class_modification_elements.addClass('js-live-after');
  } else {
    class_modification_elements.addClass('js-live-ongoing');
  }
}

function get_current_unix_time() {
  return Date.now();
}

function update_live_progress_bar (progress_bar_el, start_unix, end_unix) {
  var current_time = get_current_unix_time();

  if (current_time > start_unix && current_time < end_unix) {
    var diff = end_unix - current_time;
    var start_end_diff = end_unix - start_unix;

    var percentage = Math.round(100 - (diff / start_end_diff * 100));

    progress_bar_el.width(percentage + '%');
  }
}

function update_live_status(event_live_status_el, start_unix, end_unix) {
  check_live_status_situation(event_live_status_el, start_unix, end_unix);

  var progress_bar = event_live_status_el.find('.event__progress-bar');
  if (progress_bar.length) {
    update_live_progress_bar(progress_bar, start_unix, end_unix);
  }
}
